// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3saeU","type":"styles_type__1yYVF","choices":"styles_choices__2agXP"};